import { useContext, useEffect } from 'react';
import PrivilegeContext from '../Contexts/PrivilegeContext'

export function usePrivileges(businessUnitCode) {
    const { admin, supervisor, canReview, canProcess, canGrade, setBusinessUnitCode, businessUnitsUserCanProcess } = useContext(PrivilegeContext)

    useEffect(() => {
        if (businessUnitCode !== undefined)
        {
            setBusinessUnitCode(businessUnitCode);
        }
    }, [businessUnitCode, setBusinessUnitCode]);

    return { canProcess, canReview, canGrade, supervisor, admin, businessUnitsUserCanProcess };
}

export default usePrivileges;